import React from 'react';
import './LegalPage.css';

const RefundPolicy = () => {
  return (
    <div className="legal-page">
      <div className="legal-container">

        <div className="legal-header">
          <h1>Refund &amp; Cancellation Policy</h1>
        </div>

        <div className="legal-section">
          <p>
            SwingSetupAI is a digital subscription-based service. Once a subscription is purchased
            and activated, we do not offer refunds under any circumstances. By completing your
            purchase, you acknowledge and agree to this policy.
          </p>
          <p>
            We strive to provide a reliable and uninterrupted experience. However, in rare cases
            of technical issues or service disruptions beyond our control, we may, at our sole
            discretion, offer an extension of the subscription period as a goodwill gesture. Such
            extensions are not guaranteed and will be evaluated on a case-by-case basis.
          </p>
          <p>
            You may cancel your subscription at any time. Upon cancellation, you will continue to
            have access to the service until the end of your current billing cycle. No further
            charges will be applied after cancellation.
          </p>
          <p>
            Please note that cancellation does not entitle you to any refund for the remaining
            subscription period.
          </p>
          <p>
            We reserve the right to update or modify this policy at any time without prior notice.
            Any changes will be posted on this page, and continued use of the service constitutes
            acceptance of the updated policy.
          </p>
          <p>
            If you have any questions or concerns, please contact us at{' '}
            <a href="mailto:support@swingsetupai.com" className="legal-link">support@swingsetupai.com</a>.
          </p>
        </div>

      </div>
    </div>
  );
};

export default RefundPolicy;
